import { 
  IEvent,
  EventType,
  BubbleDestroyReason,
  createBubbleDestroyedEvent,
  createIncreasedScoreEvent,
  filterEvents,
} from 'js/bubbleCore/events';
import { removeFromPlace } from 'js/bubbleCore/handlers/removeFromPlace';
import { Place } from 'js/bubbleCore/types';
import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';

export function resolveBubblePointZoneCollisions(
  board: BubbleGameBoard,
): void {
  filterEvents(board.getEventsQueue(), EventType.BubblePointZoneCollision)
    .forEach((event) => {
      const data = board.getData();
      const queue = board.getEventsQueue();
      const {bubble, pointZone } = event.data;
      removeFromPlace(bubble, data, Place.PopOutSpace);
      data.state.score += pointZone.score;
      queue.push(createBubbleDestroyedEvent(bubble, BubbleDestroyReason.PointZone))
      if (!data.state.gameOver) queue.push(createIncreasedScoreEvent(data.state.score));
    });
};